import React from 'react';
import { times } from 'lodash-es';

import Skeleton from '../../../../../components/Skeleton';

export default {
  forecastHeader: (
    <div className="reports-and-exports-page__nav">
      <div className="reports-and-exports-page__nav-item">
        <Skeleton height={12.5} width={90} />
      </div>
    </div>
  ),
  forecastsFilters: (
    <>
      <Skeleton height={32} width={120} />
      <Skeleton height={32} width={114} />
      <Skeleton height={32} width={140} className="ml-auto" />
    </>
  ),
  forecastSubtitle: <Skeleton height={18} width={90} />,
  forecastStats: (
    <>
      <div className="forecasts-main-sidebar__stats-left">
        <Skeleton height={21} width={120} />
        <Skeleton height={18} width={80} />
        <Skeleton height={18} width={160} />
      </div>
      <div className="forecasts-main-sidebar__stats-right">
        <Skeleton height={32} width={32} />
      </div>
    </>
  ),
  forecastsSidebarValues: isRestricted => isRestricted ? (
    <div className="forecasts-main-sidebar__values">
      {times(2).map(n => (
        <Skeleton
          key={n}
          height={74}
          width="calc(50% - 8px)"
          style={{
            minWidth: 160,
            flexGrow: 1,
          }}
        />
      ))}
    </div>
  ) : (
    <div className="forecasts-main-sidebar__values">
      {times(4).map(n => (
        <div key={n} className="forecasts-main-sidebar__values-item p-a-0 bg-none">
          <Skeleton height={62} />
        </div>
      ))}
    </div>
  ),
  forecastsSidebarTakeaways: (
    <div className="forecasts-main-sidebar__takeaways-content d-flex" style={{ height: '100%' }}>
      <Skeleton height="100%" />
    </div>
  ),
  forecastsMainChart: height => (
    <Skeleton height={height} />
  ),
  forecastsMainTable: isRestricted => (
    <Skeleton height={isRestricted ? 105.5 : 183.5} />
  ),
};
